<template>
  <div class="pt-4 labelled-info">
    <div class="text-grey text-sm mb-1">{{ label }}</div>
    <div class="text-lg"><slot /></div>
  </div>
</template>

<script>
export default {

  name: 'BaseLabelledInfo',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
